import PrivacyPheybarber from './components/PrivacyPheybarber';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
    <PrivacyPheybarber></PrivacyPheybarber>
      </header>
    </div>
  );
}

export default App;
